import AssetHelper from "ftc-common/AssetHelper";
import {initSounds} from "ftc-common/sounds";
import {ScoreCalculator} from "./ScoreCalculator";
import { createRoot } from "react-dom/client";

AssetHelper.ensureProperties().then(() => {
    initSounds();

    const container = document.getElementById('reactContainer');
    if (container) {
        const root = createRoot(container)
        root.render(<ScoreCalculator />);
    } else {
        console.error("Container element not found")
    }
});